/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
import * as sharedStyles from './on-market.style';
var colour = variables.colour;
export var propertyHistory = /*#__PURE__*/css(sharedStyles.mobileInterComponentGap);
export var availability = /*#__PURE__*/css("border-top:1px solid ", colour.neutral200, ";margin-top:21px;padding-top:21px;", sharedStyles.mobileInterComponentGap, " ", media('>=desktop'), "{margin-top:24px;padding:24px 0;}");